// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { FilterArrayPipe } from '@lbca-shared/pipes/filter-array';
import { ASSETS } from '../../../../assets/assets';
import { waitingTimer } from '../../../../helpers/_old_helpers/animate';
import { GeneratePaginationPipe } from '../../../../pipes/generate-pagination.pipe';
import { LoadingComponent } from '../../../_old_general-components/loading/loading.component';
import { BodyFeedbackComponent } from '../../body-feedback/body-feedback.component';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { ClaimService } from '../../dynamic-form/sub-modules/claim/claim.service';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { PaginationComponent } from '../../pagination/pagination.component';
import { SearchBoxComponent } from '../../search-box/search-box.component';
import { SelectTreeService } from './select-tree.service';

@Component({
  selector: 'lbca-select-tree',
  templateUrl: './select-tree.component.html',
  styleUrl: './select-tree.component.scss',
  imports: [
    SearchBoxComponent,
    BodyFeedbackComponent,
    PaginationComponent,
    LoadingComponent,
    IconComponent,
  ],
  providers: [FilterArrayPipe, GeneratePaginationPipe],
})
export class SelectTreeComponent implements OnInit {
  private changeDetectorRef: any = inject(ChangeDetectorRef);
  private selectTreeService: any = inject(SelectTreeService);
  private overlay: any = inject(Overlay);
  private elementRef: any = inject(ElementRef);
  filterArrayPipe: any = inject(FilterArrayPipe);
  generatePaginationPipe: any = inject(GeneratePaginationPipe);
  private claimService: any = inject(ClaimService);
  private dynamicFormService: any = inject(DynamicFormService);
  readonly assets = inject(ASSETS);

  @ViewChild('refDispend', { static: false }) refDispend!: ElementRef;
  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
  public fieldsLabels: any = {};
  public options: Array<any> = [];
  public checkedItens: any[] = [];
  public labelValue = '';
  public helperTextValue = '';
  public isRequired = false;
  public isDisabled = false;
  public hasError = false;
  public motionFillStatus: 'selected' | 'newItens' | 'removed' | 'choosed' = 'newItens';
  public setTransitionMs: any = null;
  public selectItem: any;
  public unselectItem: any;
  public setTopTable: any;
  public setTopRemove: any;
  public setLeftTable: any;
  public setLeftRemove: any;
  public loading = false;
  public fieldItem: any;
  private waitingTimer = waitingTimer;
  public executing = false;
  private errorPopup!: ErrorOverlayClass;
  public valueInput!: string;
  public flowId!: string;
  public tagList: any = [];
  public showFilter = false;
  optionsSearch: Array<any> = [];
  paginationType!: string;
  regeneratedPagesArray: any[] = [];
  maxPages = 0;
  actualPage = 1;
  clearSearchFunctionEs!: any;
  clearDataSearch = false;
  searched = false;
  hasChild = false;
  @Input() set field(val) {
    this.fieldItem = val;
  }
  @Input('flowId') set flow(val) {
    this.flowId = val;
  }
  @Input() set type(val: 'primary' | 'secondary') {
    this.type = val;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() maxItensForPage = 15;

  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set value(val: any) {
    this.valueInput = val;
    setTimeout(() => {
      if (this.valueInput) this.fillBreadcrumb(this.valueInput);
      else {
        this.getItems();
        this.checkedItens = [];
      }
    }, 1000);
  }
  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }
  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }
  @Output('setError') errorStateEmmiter = new EventEmitter();
  @Output('validState') validStatusEmmiter = new EventEmitter();
  @Output('changeValue') changeValueEmmiter = new EventEmitter();
  @Output('changeSecundaryValue') changeSecundaryValueEmmiter = new EventEmitter();
  @Output('changeProperties') changePropertiesEmmiter = new EventEmitter();
  @Output('focusState') focusStateEmmiter = new EventEmitter();
  constructor() {
    const overlay = this.overlay;
    const elementRef = this.elementRef;

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'start'
    );
  }

  public ngOnInit(): void {
    this.fieldsLabels = this.assets.labels.components.fields;
  }
  public mouseenter(): void {
    this.errorPopup.setFocus(true);
  }
  public mouseleave(): void {
    this.errorPopup.setFocus(false);
  }
  public getFocus(): void {
    this.mainElement.nativeElement.focus();
  }
  public async motionTimers(
    target: HTMLElement,
    offSTop = 0,
    offSLeft = 0,
    delay = 0
  ): Promise<void> {
    this.setTransitionMs = delay;
    this.setLeftTable = target.offsetLeft + offSLeft;
    this.setTopTable = target.offsetTop + offSTop;
    return await this.waitingTimer(delay);
  }
  private async itemSelectMotion(
    option: any,
    target: HTMLLabelElement,
    refAppend: HTMLDivElement
  ): Promise<void> {
    option.remove = false;
    option.hide = false;
    this.setTopTable = target.offsetTop;
    this.setLeftTable = 0;
    this.selectItem = option.id;
    this.motionFillStatus = 'choosed';
    await this.motionTimers(target, -8, 0, 300);
    await this.motionTimers(refAppend, -6, 0, 300);
    await this.motionTimers(refAppend, 2, 0, 200);
    await this.motionTimers(refAppend, 0, 0, 100);
    target.remove();
    this.setTopTable = null as any;
    this.setLeftTable = null as any;
    this.selectItem = null as any;
  }
  public async selectOption(
    option: any,
    target: HTMLLabelElement,
    refAppend: HTMLDivElement
  ): Promise<void> {
    if (this.executing) return;
    this.executing = true;
    this.clearSearchValue();
    await this.itemSelectMotion(option, target, refAppend);
    this.checkedItens.push(option);
    await this.getItems(option.id, 'newItens');
    if (!option.hasChild) {
      this.hasChild = false;
      this.valueInput = option.id;
      option.checkedItem = true;
      this.claimService.showPopupFeedController.next([
        `${this.fieldItem.label} selecionado(a)`,
        'emoji--glasses icon-box ml-16',
      ]);
    } else {
      this.hasChild = true;
    }
    this.errorStateEmmiter.emit([]);
    if (option.checkedItem) {
      this.changeValueEmmiter.emit(this.valueInput);
      this.changePropertiesEmmiter.emit(option);
    }
    if (this.fieldItem.secundarySetKeyConfiguration) {
      if (this.fieldItem.secundarySetKeyConfiguration.auxEntity) {
        const {
          entityUrl,
          tableName = false,
          entityParameters,
        } = this.fieldItem.secundarySetKeyConfiguration.auxEntity;
        if (typeof entityParameters === 'object' || !Array.isArray(entityParameters)) {
          const params: any = {};
          const keys = Object.keys(entityParameters);
          keys.forEach((key) => {
            params[key] =
              this.dynamicFormService?.formControlStructure?.fieldControl?.[
                entityParameters[key]
              ]?.value;
            if (key === 'filters') {
              const filter = {};
              for (const k in entityParameters.filters) {
                filter[k] =
                  this.dynamicFormService?.formControlStructure?.fieldControl?.[
                    entityParameters.filters[k]
                  ]?.value;
              }
              params.filters = filter;
            }
          });
          const isElectronic = params.isElectronic;
          const paramsData = {
            id: this.valueInput,
            uf: params.filters.uf,
            isElectronic,
            filters: JSON.stringify(params.filters),
            tableName,
          };
          this.selectTreeService
            .getData(entityUrl, { params: paramsData })
            .subscribe((resp: any) => {
              const key = this.fieldItem.secundarySetKeyConfiguration.entityKey;
              const value = resp?.value || null;
              this.changeSecundaryValueEmmiter.emit({
                key,
                value,
              });
            });
        }
      } else {
        const inputData = this.fieldItem.secundarySetKeyConfiguration.inputData;
        let value = option[inputData] || 'undefined';
        if (!Object.keys(option).find((key) => key == inputData)) {
          const exceptionKey = this.fieldItem.secundarySetKeyConfiguration.exceptionKey;
          const exceptionKeyDictionary =
            this.fieldItem.secundarySetKeyConfiguration.exceptionKeyDictionary;
          const formStruct = this.dynamicFormService?.formControlStructure?.fieldControl;
          const property = String(formStruct?.[exceptionKey]?.value);
          value = exceptionKeyDictionary[property];
        }
        const destinyKey = this.fieldItem.secundarySetKeyConfiguration.entityKey;
        this.changeSecundaryValueEmmiter.emit({ key: destinyKey, value });
      }
    }
    this.focusStateEmmiter.emit(false);
    this.executing = false;
  }
  private async markBreadcrumbAsRemovableItens(
    index: number,
    target: HTMLDivElement
  ): Promise<void> {
    this.setTopRemove = target.offsetTop;
    this.setLeftRemove = target.offsetLeft;
    if (index < this.checkedItens.length - 1) {
      this.checkedItens
        .filter((item, filterIndex) => index < filterIndex)
        .forEach((element) => {
          element.remove = true;
          element.hide = true;
        });
    }
    await this.waitingTimer(600);
    this.setTopRemove = null as any;
    this.setLeftRemove = null as any;
  }
  public async backItem(reference: HTMLDivElement): Promise<void> {
    const option = this.checkedItens[this.checkedItens.length - 1];
    const index = this.checkedItens.length - 1;
    const itens = reference.querySelectorAll('.st-badge');
    this.removeOption(option, itens[index] as HTMLDivElement, index);
  }
  public async removeOption(option: any, target: HTMLDivElement, index: number): Promise<void> {
    if (this.executing) return;
    this.executing = true;
    this.clearSearchValue();
    this.changePropertiesEmmiter.emit(null);
    this.valueInput = null as any;
    this.setTopTable = target.offsetTop;
    this.setLeftTable = target.offsetLeft;
    await this.markBreadcrumbAsRemovableItens(index, target);
    this.setTransitionMs = 0;
    this.selectItem = option.id;
    this.unselectItem = option.id;
    const parent = option.parentId ? option.parentId : option.parent;
    await this.getItems(parent, 'removed');
    this.checkedItens = this.checkedItens.slice(0, index);
    const ref = this.refDispend ? this.refDispend.nativeElement : target;
    await this.motionTimers(target, -6, -3, 400);
    await this.motionTimers(ref, 0, 10, 600);
    this.selectItem = null as any;
    this.unselectItem = null as any;
    this.setTopTable = null as any;
    this.setLeftTable = null as any;
    this.errorStateEmmiter.emit([]);
    this.changeValueEmmiter.emit(this.valueInput);
    if (this.fieldItem.secundarySetKeyConfiguration) {
      const destinyKey = this.fieldItem.secundarySetKeyConfiguration.entityKey;
      this.changeSecundaryValueEmmiter.emit({ key: destinyKey, value: null });
    }
    this.executing = false;
    if (this.fieldItem.secundarySetKeyConfiguration) {
      const destinyKey = this.fieldItem.secundarySetKeyConfiguration.entityKey;
      this.changeSecundaryValueEmmiter.emit({
        key: destinyKey,
        value: 'undefined',
      });
    }
  }
  private async fillBreadcrumb(id = ''): Promise<void> {
    const flowId = this.flowId
      ? this.flowId
      : this.dynamicFormService.formControlStructure?.formMetadata?.flowId;
    this.selectTreeService.breadcrumbEntity(this.fieldItem.breadcrumbEntity, id, flowId).subscribe(
      (resp: any): void => {
        if (resp) {
          let item: any = null;
          if (Array.isArray(resp)) {
            item = resp[resp.length - 1];
          } else {
            item = resp;
          }
          const hasChild = item!.hasChild;
          if (!hasChild) item!.checkedItem = true;
          else this.getItems(item!.id);
          this.checkedItens = Array.isArray(resp) ? resp : [resp];
        } else {
          this.getItems();
        }
      },
      (error: any): void => {
        console.error(error);
      }
    );
  }
  private async getItems(
    parent = '0',
    motionType: 'removed' | 'newItens' = 'newItens'
  ): Promise<void> {
    this.options = [];
    this.motionFillStatus = motionType;
    this.loading = true;
    this.setTransitionMs = 0;

    const { childrenDependency = {}, itIsFiltable = false } = this.fieldItem;
    const fathers = childrenDependency.father ? childrenDependency.father : [];
    const param = {};
    if (parent == '0' && fathers.length > 0 && itIsFiltable) {
      fathers.forEach((father) => {
        if (father.entityKeyAuxWhere) {
          const formStruct = this.dynamicFormService?.formControlStructure?.fieldControl;
          param[father.entityKeyAuxWhere] = formStruct?.[father.fieldKey]?.value;
        }
      });
    }
    const flowId = this.flowId
      ? this.flowId
      : this.dynamicFormService.formControlStructure?.formMetadata?.flowId;

    this.selectTreeService
      .auxEntity({ ...this.fieldItem.bibEntity, flowId, parent }, param)
      .subscribe(
        (resp: Array<any>): void => {
          try {
            this.showFilter = resp.length > this.maxItensForPage;

            resp.sort((a, b) => {
              return a.label < b.label ? -1 : 0;
            });
            resp = resp.filter((e) => !e.deleted);

            const r = this.generatePaginationPipe.transform(resp, this.maxItensForPage);
            this.optionsSearch = resp || [];
            this.options = r.pages[0] || [];
            this.maxPages = r.numberPages;
            this.actualPage = 1;
            this.loading = false;
            this.changeDetectorRef.detectChanges();
          } catch (e) {
            this.loading = false;
          }
        },
        (error: any): void => {
          console.error('ERROR: ', error);
        }
      );
    // await this.waitingTimer(600);
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }
  public setSearchValue(searchValue: string) {
    if (searchValue) {
      this.searched = true;
      // this.tagList = searchValue
      this.options = this.generatePaginationPipe.transform(
        [
          ...this.filterArrayPipe.transform(this.optionsSearch, searchValue, 'label'),
          ...this.filterArrayPipe.transform(this.optionsSearch, searchValue, 'id'),
        ],
        this.maxItensForPage
      ).pages[0];
      this.tagList = searchValue;
    } else {
      this.actualPage = 1;
      this.options = this.generatePaginationPipe.transform(
        this.optionsSearch,
        this.maxItensForPage
      ).pages[0];
    }
    this.changeDetectorRef.detectChanges();
  }
  public clearSearchValue = () => {
    this.searched = false;
    this.actualPage = 1;
    this.tagList = [];
    this.options = this.generatePaginationPipe.transform(
      this.optionsSearch,
      this.maxItensForPage
    ).pages[0];
  };
  public clearSearchFunction($event) {
    this.clearSearchFunctionEs = $event;
    this.clearSearchFunctionEs();
  }
  isLastPage = false;
  public selectedPage(value: number): void {
    this.actualPage = value;
    const size = Math.abs(Math.ceil(this.optionsSearch?.length / this.maxItensForPage));
    this.isLastPage = size === value;
    this.options = this.generatePaginationPipe.transform(
      this.optionsSearch,
      this.maxItensForPage
    ).pages[this.actualPage - 1];
  }
  public orientation(value: 'next' | 'prev'): void {
    this.paginationType = value;
  }
  get showOptions(): boolean {
    return this.showFilter && this.options?.length > 0;
  }
  get showPagination(): boolean {
    return this.showFilter && (this.maxItensForPage === this.options?.length || this.isLastPage);
  }
}
